import DropDown from "../common/TextField/dropDown";
import React from "react";
import { useSelector, useDispatch } from "react-redux";
import { jobListingSelector } from './selector';
import {updateFilterFields, loadJobListings, clearFilter, firstPage} from './action';
import DateField from '../common/TextField/dateTime';
import useConfiguration from "../../hooks/useConfiguration";
import useSessionStorage from "../../hooks/useSessionStorage";
import TextField from "../common/TextField/withLabel";

export default () => {
    const dispatch = useDispatch();
    const config = useConfiguration();
    const storage = useSessionStorage();
    const login = storage.getItem('login');
    const { filterFields, masterDatas } = useSelector(jobListingSelector);
    const updateLocation = (target) => {
        const value = target.value;
        dispatch(updateFilterFields('location', value));
    };
    const updateFromDate = (target) => {
        const value = target.value;
        dispatch(updateFilterFields('fromDate', value));
    };
    const updateToDate = (target) => {
        const value = target.value;
        dispatch(updateFilterFields('toDate', value));
    };
    const updateSearchText = (target) => {
        const value = target.value;
        dispatch(updateFilterFields('searchText', value));
    };
    return (
        <div className="card-body">
            <div className="row">
                <DropDown name={'filterLocation'}
                      label={"Location Name"}
                      id={'filterLocation'}
                      options={masterDatas.locationList} multiple={false}
                      value={[filterFields.location]}
                      updateValue={updateLocation} isObject={true}
                      showArrow={true} divClass={"col-md-3 col-lg-3"} />
                <DateField name={"fromDate"}
                           label={"From Date"}
                           id={"fromDate"}
                           value={filterFields.fromDate}
                           updateValue={updateFromDate}
                           divClass={"date-time-field"}
                           includeTime={false} />
                <DateField name={"toDate"}
                           label={"To Date"}
                           id={"toDate"}
                           value={filterFields.toDate}
                           updateValue={updateToDate}
                           divClass={"date-time-field"}
                           includeTime={false}/>
                <TextField name={"searchText"}
                           label={"Search Text"}
                           value={filterFields.searchText}
                           updateValue={updateSearchText}
                           divClass={"col-md-2 col-lg-2"}/>
            </div>
            <div className={"row"}>
                <div className={"apply-button"}>
                    <button className={"btn btn-default button-margin"} onClick={(event) => {
                        event.preventDefault();
                        dispatch(clearFilter()).then(() => {
                            dispatch(loadJobListings({url: config.baseUrl, empId:login.employerUniqueId}));
                        })
                    }}>
                        Clear
                    </button>
                 <button className={"btn btn-primary"} onClick={(event) => {
                     event.preventDefault();
                     dispatch(loadJobListings({url: config.baseUrl, empId:login.employerUniqueId, pageToLoad: 1}));
                 }}>Apply</button>
                </div>
            </div>
        </div>
    )
}
